module.exports = __webpack_public_path__ + "static/img/5.43df2ecb.jpg";